import { CheckboxOptionType, RadioChangeEvent } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ALL_KEY } from "../../components/CustomRadioButton/enumerations/enumerations";
import {
  useGetInfiniteNews,
  useGetNewsCategory,
} from "../../hooks/News/news.hooks";

import { useNavigate } from "react-router-dom";
import { NewsCategoryResponse, NewsProps } from "../../hooks/News/data";
import { NewsContainer } from "./components";

const News: React.FC<NewsProps> = () => {
  const navigate = useNavigate();
  const PAGE_SIZE = 10;
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<string | number>(
    ALL_KEY
  );
  // const [currentPage, setCurrentPage] = useState<number>(1);
  // const [totalPages, setTotalPages] = useState<number>(0);

  const {
    data: news,
    isLoading: loadingNews,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isError,
  } = useGetInfiniteNews(
    {
      // page: currentPage,
      page_size: PAGE_SIZE,
      category_id: selectedCategory === ALL_KEY ? undefined : selectedCategory,
    },
    {
      getNextPageParam: (lastPage: any, pages: any) => {
        const { page, total_pages } = lastPage;
        return page < total_pages ? page + 1 : undefined;
      },
    }
  );

  const { data: newsCategory, isLoading: loadingCategory } = useGetNewsCategory(
    {}
  );

  const [options, setOptions] = useState<
    (string | number | CheckboxOptionType<any>)[]
  >([]);

  // const onPageChange = (page: number, pageSize: number) => {
  //   console.log(page);
  //   setCurrentPage(page);
  //   scrollToTop("main-layout");
  // };

  // useEffect(() => {
  //   if (!news) return;
  //   setTotalPages(news.total_pages);
  //   console.debug("news", news);
  // }, [news]);

  const onChange = (e: RadioChangeEvent) => {
    setSelectedCategory(e.target.value);
  };

  // const handlePrevPage = () => {
  //   if (currentPage > 1) setCurrentPage((prevState) => prevState - 1);
  // };
  // const handleNextPage = () => {
  //   if (currentPage < totalPages) setCurrentPage((prevState) => prevState + 1);
  // };

  useEffect(() => {
    if (!newsCategory) return;
    setOptions(
      newsCategory.map((news: NewsCategoryResponse) => {
        return {
          value: news.id,
          label: t([`${news.name}`]),
        };
      })
    );
  }, [newsCategory]);

  const handleOpenDetail = (id: number) => {
    navigate(`/news/detail/${id}`);
  };

  return (
    <NewsContainer
      options={options}
      selectedCategory={selectedCategory}
      onChange={onChange}
      loadingCategory={loadingCategory}
      news={news}
      handleOpenDetail={handleOpenDetail}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      loadingNews={loadingNews}
      // currentPage={currentPage}
      // onPageChange={onPageChange}
      // handlePrevPage={handlePrevPage}
      // handleNextPage={handleNextPage}
      // totalPages={totalPages}
    />
  );
};

export default News;
